import {
  BarChart3,
  BookOpen,
  Calendar,
  Check,
  Compass,
  Headset,
  KeyRound,
  Lightbulb,
  Pencil,
  Star,
  X,
  type LucideIcon,
} from 'lucide-react';

import type { LaikaActionId } from './types';

export const LAIKA_ACTION_ICONS: Record<LaikaActionId, LucideIcon> = {
  helpCenter: BookOpen,
  howToUse: Lightbulb,
  findPage: Compass,
  enableDataAccess: KeyRound,
  nextAppointments: Calendar,
  loyalClient: Star,
  statistics: BarChart3,
  documentation: BookOpen,
  contactHuman: Headset,
  confirm_yes: Check,
  confirm_edit: Pencil,
  confirm_abort: X,
};

export function resolveActionStyleClass(style: string): string {
  if (style === 'success' || style === 'accent') return 'accent';
  if (style === 'danger') return 'danger';
  return 'default';
}
